import Image from 'next/image';
import dynamic from "next/dynamic";

import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { socialCardKeys } from 'src/constants/socialcard.constant'

const ReactStars = dynamic(() => import("react-stars"), {
  ssr: false,
});

import { textColors } from 'src/constants/wall.constant';

import ClassNames from 'src/components/componentHelper/ClassNames'

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const QuoteTextReviewCard = ({ cardWidth, cardItem,darkModeEnabled, cardFontColor, fontStyle, cardBackgroundObject, darkCardTheme, linkColor, highlightColor, engagementDisabled, smallSize, refresh, shortenText,ratingColor  }) => {
      
  const options = {
    replace: domNode => {
       const attribProps = attributesToProps(domNode.attribs);

       if (domNode.name === 'a') {
          return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
       }

       else if(domNode.name === 'b'){
        let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
        if (darkModeEnabled) {
          bStyle.color = '#726c6c';
        }
        return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
     }
    }
 }

  return (
        <div className="mx-auto py-3 mt-3 text-center" style={{maxWidth:'41rem',minWidth:'100%' }}>
      
      <div className={" rounded-md mb-6 lg:mb-0 "} >


      <div className="flex justify-center items-center ">
    
  <div className=" text-center">
   
  {
                             cardItem[socialCardKeys.starRating] && cardItem[socialCardKeys.starRating]>0 ? 
                             <div className="whitespace-nowrap flex justify-center mb-3" style={{ marginRight: 16, marginTop:'-10px' }}>
                                     <ReactStars
                                         count={5}
                                         className='flex'
                                         value={cardItem[socialCardKeys.starRating]}
                                         edit={false}
                                         size={32}
                                         color2={ratingColor?ratingColor:'#f59e0b'}
                                     />
                                 </div>
                                 :
                                 null
                          }

    <div className=" my-2 text-sm md:text-base">
 
      <div className={ClassNames('mt-2',fontStyle && fontStyle!==''?`font-${fontStyle}`:'')}  style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.0rem":"0.9rem",lineHeight: !smallSize? 1.5: 1.7 }}>
      {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                <>
                   <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="quote-left"
            className="w-5 pr-2 text-gray-400 inline-block mb-3" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="currentColor"
              d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z">
            </path>
          </svg>
                   {       
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent], options)
                
                   }

                  </>
                  :
                  null
               }

        </div>
      <div className='flex mx-auto items-center justify-center space-x-2 mt-6'>
      {
        cardItem[socialCardKeys.authorImage]?
      <a className="flex justify-center w-8" href={cardItem[socialCardKeys.messageLink] || void(0)} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer" >
          <Image src={cardItem[socialCardKeys.authorImage] || `https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} loading='lazy' width={32} height={32} className="rounded-full shadow-md w-8 h-8 object-cover" />
        </a>
        :
        null
        }
      <div className={ClassNames(cardItem[socialCardKeys.authorImage]?'text-left':'text-center','flex flex-col ')}>
        <a className="text-base cursor-pointer truncate font-medium opacity-80" href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), lineHeight: 1.2, textDecoration: 'none' } : { color: (cardFontColor || textColors.light.primary), lineHeight: 1.2, textDecoration: 'none' }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">
          {cardItem[socialCardKeys.authorName]}
        </a>
        
    { (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='')  ?
        <a className={!darkModeEnabled ? 'text-gray-700 mt-1 block text-sm' : 'text-gray-300 mt-1 block text-sm'} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.workTitle]}</a>
        :
          (cardItem[socialCardKeys.authorTagline] && cardItem[socialCardKeys.authorTagline]!=='') ?
          <a className={!darkModeEnabled ? 'text-gray-700 mt-1 block text-sm' : 'text-gray-300 mt-1 block text-sm'} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.authorTagline]}</a>
                :
                (cardItem[socialCardKeys.authorUsername] && cardItem[socialCardKeys.authorUsername]!=='') ?
                <a className={!darkModeEnabled ? 'text-gray-700 mt-1 block' : 'text-gray-300 mt-1 block'} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target="_blank" rel="noreferrer noopener">               
                      {`@${cardItem[socialCardKeys.authorUsername]}`}
                  </a>
                  :
                null
        }

      </div>
</div>
    </div>
  </div>
</div>

     

          

  

      </div>

    


</div>
    );
};

export default QuoteTextReviewCard;